import React from "react";
import About from "./About";
import Contact from "./Contact";
import Features from "./Features";
import Footer from "./Footer";
import Footer1 from "./Footer1"; 
import NavBar from "./NavBar";
import Project from "./Project";

const App =()=> {

  return (
    <>
    <NavBar />
    <About />
    <Project />
    <Features />
    <Contact />
    <Footer1 />
    <Footer />
   
    </>
  );
}

export default App;
